import { useEffect } from 'react';

const WHMCS = () => {
    useEffect(() => {
        // Redirect to actual static file URL
        window.location.href = '/plugins/plugin/whmcs.zip';
    }, []);
    return <>
    </>;
};

export default WHMCS;
